@if (isReady) {
  <ix-dropdown-button
    (click)="$event.stopPropagation()"
    [id]="dropdownId"
    class="full-button"
    icon="context-menu"
    onkeypress=""
    variant="tertiary">
    <ix-dropdown-item
      (click)="onShowQrClick()"
      icon="qr-code"
      onkeypress="">
      {{ 'dpp.passport_overview.show_qr_code' | translate }}
    </ix-dropdown-item>
    <ix-dropdown-item
      (click)="onDeleteClick()"
      icon="trashcan"
      onkeypress="">
      {{ 'dpp.passport_overview.delete_passport' | translate }}
    </ix-dropdown-item>
  </ix-dropdown-button>
}
